import React from 'react';
import styled from 'styled-components';
import download from '../../assets/images/download.svg';

const DownloadItem = styled.a`
    padding: 12px 15px;
    margin-bottom: 8px;
    background-color: #f5f5f5;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    display: flex;
    align-items: center;
    
    &:hover {
        background-color: #e8e8e8;
    }
    
    &::before {
        content: "";
        margin-right: 10px;
        font-size: 1.2em;
        background-image: url(${download});
        background-size: contain;
        background-repeat: no-repeat;
        width: 24px;
        height: 24px;
    }
`;

const StyledHeader = styled.h3`
    margin-top: 25px;
    font-family: "Roboto Slab", serif;
    font-weight: 500;
    color: var(--forest-green);
`;

export const DownloadsWidget = ({downloads}) => {
    return (
        <>
            <StyledHeader>Downloads</StyledHeader>
            {downloads && downloads.length > 0 && downloads.map((download) => (
                <DownloadItem 
                    key={download.id} 
                    href={download.url}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {download.caption}
                </DownloadItem>
            ))}
        </>
    );
}
